import clsx from "clsx"


export interface InputDefaults<T> {
  name: string,
  label?: string,
  placeholder?: string,
  ariaLabel?: string,
  helpText?: string,
  errorClassName?: string,
  unstyled?: boolean,
  wrapped?: boolean,
  readOnly?: boolean,
  disabled?: boolean,
  onChange?: (newval: T) => T;
}


export const inputClasses = (readOnly: boolean, error: boolean) => clsx(
  "w-full px-4 py-2 rounded-xl border shadow-sm focus:ring-2 text-sm",
  !readOnly && "bg-background",
  readOnly && "bg-muted",
  "focus:ring-primary",
  error && "border-danger",
)
